/* global Swiper */
(function () {
  'use strict';

  function initHeroSlideshow() {
    var heroSwipers = document.querySelectorAll('.hero-swiper');

    heroSwipers.forEach(function (swiperEl) {
      if (swiperEl.swiper) return;
      if (typeof Swiper === 'undefined') {
        console.warn('Swiper is not loaded');
        return;
      }

      var autoplayEnabled = swiperEl.dataset.autoplay === 'true';
      var autoplayDuration = parseInt(swiperEl.dataset.duration) || 3000;
      var hero = swiperEl.closest('.beacon-hero');
      var bulletsWrapper = hero?.querySelector('.hero_carouselBullets__u1oGg');
      var bullets = bulletsWrapper ? bulletsWrapper.querySelectorAll('.hero_bullet__NvVlu') : [];
      var pauseBtn = hero?.querySelector('.hero_pause__LsSZ3');
      var slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
      if (slideCount === 0) return;

      var isPaused = false;
      var isHovering = false;
      var currentSlideIndex = 0;

      var rafId = null;
      var tickStart = 0;
      var elapsed = 0;

      var swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: slideCount > 1,
        speed: 600,
        allowTouchMove: true,
        touchEventsTarget: 'container',
        on: {
          init: function () {
            updateBullets(0);
            updateSlideAria(0);
            handleVideoPlayback(0);
            if (autoplayEnabled) {
              // Delay autoplay so slide 1 stays LCP and offscreen videos stay unloaded.
              var start = function () {
                if (!isPaused) startAutoplay();
              };
              var delayMs = window.matchMedia('(max-width: 899px)').matches ? 8000 : 5000;
              var scheduleStart = function () {
                setTimeout(start, delayMs);
              };
              if (document.readyState === 'complete') {
                scheduleStart();
              } else {
                window.addEventListener('load', scheduleStart, { once: true });
              }
            }
          },
          slideChange: function (sw) {
            currentSlideIndex = sw.realIndex;
            updateBullets(currentSlideIndex);
            updateSlideAria(currentSlideIndex);
            handleVideoPlayback(currentSlideIndex);
            if (autoplayEnabled && !isPaused) {
              restartAutoplay();
            }
          },
          touchStart: function () {
            if (autoplayEnabled) {
              pauseRaf();
            }
          },
          touchEnd: function () {
            if (autoplayEnabled && !isPaused) {
              resumeRaf();
            }
          }
        }
      });

      function updateBullets(activeIndex) {
        bullets.forEach(function (bullet, index) {
          bullet.classList.toggle('hero_bulletActive__GIl3Z', index === activeIndex);
        });
      }

      function updateSlideAria(realIndex) {
        var allSlides = swiperEl.querySelectorAll('.swiper-slide');
        allSlides.forEach(function (slide) {
          var idx = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
          if (isNaN(idx)) return;
          var isActive = idx === realIndex;
          slide.setAttribute('aria-hidden', String(!isActive));
          var container = slide.querySelector('.hero-slide_container__X_nkd');
          if (container) {
            container.setAttribute('aria-hidden', String(!isActive));
          }
          slide.querySelectorAll('a').forEach(function (link) {
            link.setAttribute('tabindex', isActive ? '0' : '-1');
          });
        });
      }

      function isDesktopViewport() {
        return window.matchMedia('(min-width: 900px)').matches;
      }

      function ensureVideoSources(video) {
        var sources = video.querySelectorAll('source[data-src]');
        if (!sources.length) return;
        sources.forEach(function (source) {
          source.setAttribute('src', source.getAttribute('data-src'));
          source.removeAttribute('data-src');
        });
        video.load();
      }

      function handleVideoPlayback(realIndex) {
        var desktop = isDesktopViewport();
        var allSlides = swiperEl.querySelectorAll('.swiper-slide');
        allSlides.forEach(function (slide) {
          var idx = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
          if (isNaN(idx)) return;
          var isActive = idx === realIndex;
          if (slide.dataset.mediaType !== 'video') return;

          slide.querySelectorAll('.hero-slide_video__2_eX0').forEach(function (wrap) {
            var video = wrap.querySelector('video');
            if (!video) return;

            var isDesktopAsset = wrap.classList.contains('breakpoint-aware-asset_desktopAsset__EwAg_');
            var isMobileAsset = wrap.classList.contains('breakpoint-aware-asset_mobileAsset__r9_CW');
            var matchesBreakpoint = desktop ? isDesktopAsset : isMobileAsset;
            var shouldPlay = isActive && matchesBreakpoint && wrap.dataset.autoplay === 'true';

            if (shouldPlay) {
              ensureVideoSources(video);
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        });
      }

      bullets.forEach(function (bullet, index) {
        bullet.addEventListener('click', function () {
          if (index < 0 || index >= slideCount) return;
          if (typeof swiper.slideToLoop === 'function') {
            swiper.slideToLoop(index);
          } else {
            swiper.slideTo(index);
          }
          if (autoplayEnabled && !isPaused) {
            restartAutoplay();
          }
        });
      });

      // ── Autoplay via requestAnimationFrame ──
      //
      // Single clock: rAF tracks elapsed time, sets the bullet bar width,
      // and advances the slide the instant time is up. No setTimeout,
      // no animationend, no drift.

      function setBarProgress(pct) {
        var bullet = bullets[currentSlideIndex];
        if (!bullet) return;
        bullet.style.setProperty('--bar-progress', Math.min(pct, 100) + '%');
      }

      function tick(now) {
        if (!tickStart) tickStart = now;
        var dt = now - tickStart;
        var total = elapsed + dt;
        var pct = (total / autoplayDuration) * 100;

        setBarProgress(pct);

        if (total >= autoplayDuration) {
          if (swiper && !swiper.destroyed) {
            swiper.slideNext();
          }
          return;
        }
        rafId = requestAnimationFrame(tick);
      }

      function startRaf() {
        stopRaf();
        tickStart = 0;
        rafId = requestAnimationFrame(tick);
      }

      function stopRaf() {
        if (rafId) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
      }

      function pauseRaf() {
        if (tickStart) {
          elapsed += performance.now() - tickStart;
        }
        tickStart = 0;
        stopRaf();
      }

      function resumeRaf() {
        if (isPaused || isHovering) return;
        tickStart = 0;
        rafId = requestAnimationFrame(tick);
      }

      function startAutoplay() {
        if (!autoplayEnabled || isPaused) return;
        elapsed = 0;
        setBarProgress(0);
        var bullet = bullets[currentSlideIndex];
        if (bullet) bullet.classList.add('hero_bulletAutoplayActive');
        startRaf();
      }

      function stopAutoplay() {
        stopRaf();
        elapsed = 0;
        tickStart = 0;
        bullets.forEach(function (bullet) {
          bullet.classList.remove('hero_bulletAutoplayActive');
          bullet.style.removeProperty('--bar-progress');
        });
      }

      function restartAutoplay() {
        stopAutoplay();
        startAutoplay();
      }

      // ── Pause button ──

      if (pauseBtn) {
        pauseBtn.addEventListener('click', function () {
          isPaused = !isPaused;
          pauseBtn.setAttribute('aria-pressed', isPaused ? 'false' : 'true');
          pauseBtn.setAttribute('aria-label', isPaused ? 'Start carousel playback' : 'Pause carousel playback');

          var svgPath = pauseBtn.querySelector('path');
          if (svgPath) {
            if (isPaused) {
              svgPath.setAttribute('d', 'M14 10L7.70968 4H6.5V16H7.70968L14 10Z');
            } else {
              svgPath.setAttribute('d', 'M7 16L7 4M13 16L13 4');
            }
            svgPath.setAttribute('fill', 'none');
            svgPath.setAttribute('stroke', 'currentColor');
            svgPath.setAttribute('stroke-width', '2');
            svgPath.setAttribute('stroke-linejoin', 'bevel');
          }

          if (isPaused) {
            pauseRaf();
          } else {
            elapsed = 0;
            restartAutoplay();
          }
        });
      }

      // Hover does not pause autoplay

      // ── Tab visibility ──

      document.addEventListener('visibilitychange', function () {
        if (!autoplayEnabled) return;
        if (document.hidden) {
          pauseRaf();
        } else if (!isPaused && !isHovering) {
          restartAutoplay();
        }
      });

      // ── CTA button clicks ──

      swiperEl.querySelectorAll('.hero-slide__button').forEach(function (button) {
        button.addEventListener('click', function (e) {
          e.stopPropagation();
          var parentLink = button.closest('a');
          if (parentLink && parentLink.href) {
            window.location.href = parentLink.href;
          }
        });
      });

      swiperEl.swiper = swiper;
    });
  }

  function bootHeroSlideshow() {
    if (typeof Swiper === 'undefined') {
      document.addEventListener('swiper-loaded', initHeroSlideshow, { once: true });
      return;
    }
    initHeroSlideshow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootHeroSlideshow);
  } else {
    bootHeroSlideshow();
  }

  if (typeof document.addEventListener !== 'undefined') {
    document.addEventListener('shopify:section:load', function (event) {
      if (event.detail.sectionId && document.querySelector('#' + event.detail.sectionId + ' .hero-swiper')) {
        bootHeroSlideshow();
      }
    });
  }
})();
